// 外网登录模块

import http from '../utils/fetch'

// 注册
export function signUp(params: any) {
	return http.post('login/signUp', {
		body: JSON.stringify(params)
	})
}

// 登录（手机号和密码）
export function signIn(params: any) {
	return http.post('login/signIn', {
		body: JSON.stringify(params)
	})
}

// 登录（手机号和验证码）
export function signInByCode(params: any) {
	return http.post('login/userPhoneAndcheckCode', {
		body: JSON.stringify(params)
	})
}

// 发送验证码
export function sendCode(params: any) {
	return http.get('login/sendCode', {
		body: params,
	})
}

// 重置密码第一步
export function checkPhoneAndCode(params: any) {
	return http.post('login/checkUserPhoneAndCheckCode', {
		body: JSON.stringify(params)
	})
}

// 重置密码第二步
export function resetPassword(params: any) {
	return http.post('login/pwdReset', {
		body: JSON.stringify(params)
	})
}